import { FC } from 'react'

import { GlobalLoadingLink } from 'src/components/atoms/dataDisplays/GlobalLoadingLink'
import { ProjectListTableRow } from 'src/components/organisms'

import { ProfileEntity, SelectableProjectEntity } from 'src/types'

type Props = {
  projects: SelectableProjectEntity[]
  profile: ProfileEntity
  onSelectProject: (project: SelectableProjectEntity) => void
  className?: string
}

export const ProjectListBody: FC<Props> = ({ projects, profile, onSelectProject, className }) => {
  const row = (project: SelectableProjectEntity, index: number) => {
    return (
      <ProjectListTableRow
        project={project}
        profile={profile}
        rowNumber={index + 1}
        onSelectProject={onSelectProject}
      />
    )
  }

  return (
    <div className={className}>
      <div>
        {projects.map((project, index) => (
          <div
            key={project.id}
            className="tw-mb-8 last:tw-mb-0  tw-border-b last:tw-border-0 tw-border-border-secondary"
          >
            {project.isDeleting ? (
              row(project, index)
            ) : (
              <GlobalLoadingLink
                href={`/projects/${project.id}`}
                className={project.isDeleting ? 'tw-cursor-default' : 'tw-cursor-pointer'}
              >
                {row(project, index)}
              </GlobalLoadingLink>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
